<div class="checkbox-group" [ngClass]="{
            'mb-0': marginBottomZero
        }" [id]="id" (click)="onInputChange()">
    <i [ngClass]="{
        'fa-solid fa-square-check': isChecked,
        'fa-regular fa-square': !isChecked
    }"></i>
    <label>{{label}}</label>
</div>